import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const AdminPrivateRoute = (props) => {
  const { Component } = props;
  const userType = props.userType;
  const myAccount = props.myAccount;

  if (userType === "Admin" && myAccount) {
    return <Component {...props} />;
  } else {
    return <Navigate to={"/adminlogin"} />;
  }
};

export default AdminPrivateRoute;
